import { Skeleton, Space } from 'antd';

export const LoaderRow = () => (
  <Space>
    <Skeleton.Input style={{ height: 20, width: 350 }} active />
    <Skeleton.Input style={{ height: 20, width: 60 }} active />
    <Skeleton.Input style={{ height: 20, width: 400 }} active />
  </Space>
);

export const Loader = () => (
  <Space direction="vertical" size="middle">
    <LoaderRow />
    <LoaderRow />
    <LoaderRow />
    <LoaderRow />
    <LoaderRow />
  </Space>
);
